import { EmptyStateContainer, EmptyStateSubtitle, Title } from './Styled';
import { NoGoalsEmptyStateProps } from '../types';

export const NoGoalsEmptyState = ({ Icon, title, subtitle }: NoGoalsEmptyStateProps) => {
  return (
    <EmptyStateContainer role="row">
      <Icon />
      <Title>{title}</Title>
      <EmptyStateSubtitle>{subtitle}</EmptyStateSubtitle>
    </EmptyStateContainer>
  );
};
